var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWishlistIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2096 7.5846L7.56522 11.2384L3.9208 7.5846L2.09895 5.75804C1.12283 4.71368 1.12283 3.08286 2.09895 2.10422C3.07507 1.05986 4.70169 1.05986 5.74337 2.10422L7.56522 3.93077L9.38779 2.10422C10.3639 1.05986 11.9905 1.05986 13.0315 2.10422C14.0076 3.14786 14.0076 4.77941 13.0315 5.75804L11.2096 7.5846ZM13.8778 1.12561C12.3809 -0.375205 9.90779 -0.375205 8.41155 1.12561L7.50027 2.03853L6.58899 1.12561C5.09203 -0.375205 2.61967 -0.375205 1.12272 1.12561C-0.374239 2.62643 -0.374239 5.10517 1.12272 6.60599L2.034 7.51963L7.50027 13L12.9665 7.51963L13.8778 6.60599C15.3741 5.10517 15.3741 2.69144 13.8778 1.12561Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWishlistIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wishlist_icon.440568d1.svg";
export { ForwardRef as ReactComponent };